import { render, staticRenderFns } from "./tasting_dashboard.vue?vue&type=template&id=80c2c712&scoped=true"
import script from "./tasting_dashboard.vue?vue&type=script&lang=js"
export * from "./tasting_dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c2c712",
  null
  
)

export default component.exports